import { useState } from "react";
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useGlobalOpsi } from "../components/GlobalOpsi";
export default function Register({ requestSubmitGuard = async () => true }) {
  const { globalOpsi } = useGlobalOpsi();
  const opsiCabang = Array.isArray(globalOpsi?.opsiCabang) ? globalOpsi.opsiCabang : [];
  const opsiJabatan = [
    { value: "Manager", label: "Manager" },
    { value: "Foreman", label: "Foreman" },
    { value: "Staff", label: "Staff" },
    { value: "Lainnya", label: "Lainnya" },
    { value: "Pembantu_Umum", label: "Pembantu Umum" },
    { value: "Staff_IT", label: "Staff IT" },
    { value: "Tireman", label: "Tireman" },
    { value: "Checker", label: "Checker" },
    { value: "Admin_Lokasi", label: "Admin Lokasi" },
  ];

  const [nama, setNama] = useState("");
  const [username, setUsername] = useState("");
  const [kodeCabang, setKodeCabang] = useState("");
  const [jabatan, setJabatan] = useState("");
  const [userLevel, setUserLevel] = useState("");
  const [password, setPassword] = useState("");
  const [foto, setFoto] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const maxAssignableUserLevel = String(kodeCabang || "").trim().toUpperCase() === "C-1" ? 8 : 7;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nama.trim() || !username.trim() || !kodeCabang || !jabatan || userLevel === "" || !password) {
      setAlert({ type: "danger", message: "Data belum lengkap" });
      return;
    }

    if (nama.trim().length > 50) {
      setAlert({ type: "danger", message: "Nama pegawai maksimal 50 karakter" });
      return;
    }

    if (username.trim().length > 50) {
      setAlert({ type: "danger", message: "Username maksimal 50 karakter" });
      return;
    }

    if (username.trim().length < 3) {
      setAlert({ type: "danger", message: "Username minimal 3 karakter" });
      return;
    }

    if (password.length < 6) {
      setAlert({ type: "danger", message: "Password minimal 6 karakter" });
      return;
    }

    const userLevelNumber = Number(userLevel);
    if (!Number.isInteger(userLevelNumber) || userLevelNumber < 0 || userLevelNumber > 8) {
      setAlert({ type: "danger", message: "User level harus integer 0-8" });
      return;
    }
    if (String(kodeCabang || "").trim().toUpperCase() !== "C-1" && userLevelNumber > 7) {
      setAlert({ type: "danger", message: "User Cabang hanya boleh menggunakan user level 0-7" });
      return;
    }

    setLoading(true);
    setAlert(null);

    try {
        const passed = await requestSubmitGuard("Guard Submit: Register User Baru");
        if (!passed) {
          setLoading(false);
          return;
        }
        const formData = new FormData();
        formData.append("nama", nama.trim());
        formData.append("username", username.trim());
        formData.append("kode_cabang", kodeCabang);
        formData.append("jabatan", jabatan);
        formData.append("user_level", String(userLevelNumber));
        formData.append("password", password);
        if (foto) formData.append("foto", foto);

        const response = await api.post(
          `${backendPort}/api/auth/register`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        const data = response.data;

        setAlert({ type: "success", message: data.message || "Register berhasil" });
        setNama("");
        setUsername("");
        setKodeCabang("");
        setJabatan("");
        setUserLevel("");
        setPassword("");
        setFoto(null);
        setLoading(false);

    } catch (err) {
      if (err.response) {
            // error dari server (400, 401, 500, dll)
            setAlert({
            type: "danger",
            message: err.response.data?.message || "Register gagal",
            });
        } else {
            // error network / server mati
            setAlert({
            type: "danger",
            message: "Server tidak merespon",
            });
        }
      setLoading(false);
    }
  };

  return (
    <div className="w-100">
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="row g-2 align-items-end">
          <div className="col-2">
            <label className="form-label mb-1">Nama Pegawai</label>
            <input
              type="text"
              className="form-control form-control-sm"
              name="register_nama_pegawai"
              autoComplete="off"
              value={nama}
              onChange={(e) => setNama(e.target.value)}
              required
              maxLength={50}
            />
          </div>

          <div className="col-2">
            <label className="form-label mb-1">Username</label>
            <input
              type="text"
              className="form-control form-control-sm"
              name="register_target_username"
              autoComplete="off"
              data-lpignore="true"
              data-1p-ignore="true"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              minLength={3}
              maxLength={50}
            />
          </div>

          <div className="col-2">
            <label className="form-label mb-1">Cabang</label>
            <select
              className="form-select form-select-sm"
              value={kodeCabang}
              onChange={(e) => {
                const nextKodeCabang = e.target.value;
                setKodeCabang(nextKodeCabang);
                if (String(nextKodeCabang || "").trim().toUpperCase() !== "C-1" && Number(userLevel) > 7) {
                  setUserLevel("");
                }
              }}
              required
            >
              <option value="">-Pilih Cabang-</option>
              {opsiCabang.map((x) => (
                <option key={x.kode_cabang} value={x.kode_cabang}>
                  {x.nama_cabang}
                </option>
              ))}
            </select>
          </div>

          <div className="col-2">
            <label className="form-label mb-1">Posisi</label>
            <select
              className="form-select form-select-sm"
              value={jabatan}
              onChange={(e) => setJabatan(e.target.value)}
              required
            >
              <option value="">-Pilih Posisi-</option>
              {opsiJabatan.map((x) => (
                <option key={x.value} value={x.value}>
                  {x.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-2">
            <label className="form-label mb-1">User Level</label>
            <select
              className="form-select form-select-sm"
              value={userLevel}
              onChange={(e) => setUserLevel(e.target.value)}
              required
            >
              <option value="">-Pilih Level-</option>
              {Array.from({ length: maxAssignableUserLevel + 1 }, (_, i) => (
                <option key={i} value={i}>
                  {i}
                </option>
              ))}
            </select>
          </div>

          <div className="col-2">
            <label className="form-label mb-1">Password</label>
            <div className="input-group input-group-sm">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                name="register_target_password"
                autoComplete="new-password"
                data-lpignore="true"
                data-1p-ignore="true"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
            />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Sembunyikan password" : "Tampilkan password"}
              >
                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
              </button>
            </div>
          </div>
        </div>

        <div className="row g-2 mt-2">
          <div className="col-4">
            <label className="form-label mb-1">Upload Foto</label>
            <input
              type="file"
              accept="image/*"
              className="form-control form-control-sm"
              onChange={(e) => setFoto(e.target.files?.[0] || null)}
            />
          </div>

          <div className="col-6"></div>

          <div className="col-2 d-grid">
            <label className="form-label mb-1 text-white">.</label>
            <button type="submit" className="btn btn-primary btn-sm w-100" disabled={loading}>
              {loading ? "Memproses..." : "Submit"}
            </button>
          </div>
        </div>

        <div className="mt-2">
          <div className="small text-muted">
            <div>Aturan password:</div>
            <div>1. Password minimal 6 karakter.</div>
            <div>2. Gunakan kombinasi karakter yang aman dan tidak mudah ditebak.</div>
          </div>
        </div>
      </form>

      {alert && (
        <div className={`alert alert-${alert.type} mt-3`}>
          {alert.message}
        </div>
      )}
    </div>
  );
}
